import React from 'react'

import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'
import { getTranslate } from 'react-localize-redux'

import '../../../assets/internship-state-pellet.scss'

const DEFAULT_DIMENSIONS = 'square-20'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const StatesPellet = ({ color, dimensions = DEFAULT_DIMENSIONS, icon, tooltipTitle, secondaryIcon, secondaryIconColor, showLabel, t }) => {
  return (
    <Tooltip placement='top' title={typeof tooltipTitle === 'string' ? t(tooltipTitle) : tooltipTitle}>
      <div className='internship-state-pellet'>
        <div className='icon-container'>
          <div className={`primary-icon ${dimensions}`} style={{ backgroundColor: color }}>
            {
              icon === null
                ? null
                : <FontAwesomeIcon icon={icon} style={{ margin: 'auto' }} />
            }
          </div>
          {secondaryIcon &&
            <div className='secondary-icon' style={secondaryIconColor ? { color: secondaryIconColor } : {}}>
              <FontAwesomeIcon icon={secondaryIcon} />
            </div>}
        </div>
        {showLabel ? <div style={{ marginLeft: secondaryIcon ? '11px' : '5px' }}>{tooltipTitle}</div> : null}
      </div>
    </Tooltip>
  )
}

export default connect(mapStateToProps)(StatesPellet)
